module.exports = __webpack_public_path__ + "img/profile-placeholder.6c1b912e.svg";